import { render, staticRenderFns } from "./CfgGrupos.vue?vue&type=template&id=3af16e62&scoped=true&"
import script from "./CfgGrupos.vue?vue&type=script&lang=js&"
export * from "./CfgGrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af16e62",
  null
  
)

export default component.exports